import { Checkbox, CheckboxProps } from 'primereact/checkbox';
import React from 'react';
import styled from 'styled-components';
import { FlexContainer } from '../styled-ui';

const StyledContainer = styled(FlexContainer)`
  margin-bottom: var(--small-padding);

  & label {
    font-size: var(--small-font-size);
    line-height: var(--small-line-height);
    font-weight: 500;
  }
`;

type AppCheckboxPropsType = {
  key: string;
  label: string;
  className?: string;
} & CheckboxProps;

export const AppCheckbox: React.FC<AppCheckboxPropsType> = ({
  key,
  label,
  className,
  name,
  checked,
  onChange,
  ...rest
}) => {
  return (
    <StyledContainer
      key={key}
      className={className}
      align="center"
      justify="flex-start"
    >
      <Checkbox
        inputId={key}
        name={name}
        onChange={onChange}
        checked={checked}
        {...rest}
      />
      <label htmlFor={key} className="ml-2">
        {label}
      </label>
    </StyledContainer>
  );
};
